// import { useState, useEffect } from "react";
// import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
// import { Link, useLocation } from "react-router-dom";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import "./Sidebar.css";
// import Groups2Icon from "@mui/icons-material/Groups2";
// import NoteAddIcon from "@mui/icons-material/NoteAdd";
// import AddIcon from "@mui/icons-material/Add";
// import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
// import { getSacivDetails } from "../api/User";
// import LogoutIcon from "@mui/icons-material/Logout";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import AccountBoxIcon from "@mui/icons-material/AccountBox";
// import Tooltip from "@mui/material/Tooltip";

// const Sidebars = ({ sidebar }) => {
//   const [activeMenu, setActiveMenu] = useState("/");
//   const location = useLocation();
//   const roleId = sessionStorage.getItem("role_id");
//   const user_id = sessionStorage.getItem("user_id");
//   const token = sessionStorage.getItem("token");
//   const role = sessionStorage.getItem("role");
//   const username = sessionStorage.getItem("username");
//   const [sachivDetails, setSachivDetails] = useState([]);

//   const sidebarMenuItems = [
//     ...(roleId === "2"
//       ? [
//           {
//             label: "Gram Sabha Scheduled Meetings",
//             icon: SummarizeIcon,
//             path: "/gram-sabha-meeting",
//           },
//           {
//             label: "Minutes of Gram Sabha",
//             icon: Groups2Icon,
//             path: "/gram-sabha-mom",
//           },
//         ]
//       : []),

//     ...(roleId === "1"
//       ? [
//           {
//             label: "Gram Sabha Scheduled Meetings",
//             icon: Groups2Icon,
//             path: "/ViewMeetingForGramSabhaAdmin",
//           },
//           {
//             label: "Reports",
//             icon: BarChartIcon,
//             subItems: [
//               {
//                 label: "District wise Reports",
//                 icon: BarChartIcon,
//                 path: "/ceozp-report",
//               },
//               {
//                 label: "Gram Sabha Report",
//                 icon: BarChartIcon,
//                 path: "/gram-sabha-report",
//               },
//               {
//                 label: "Income Verification Report",
//                 icon: BarChartIcon,
//                 path: "/scheme-report",
//               },
//               {
//                 label: "Special Gram Sabha Status",
//                 icon: BarChartIcon,
//                 path: "/special-gram-sabha-status",
//               },
//             ],
//           },
//         ]
//       : []),

//     ...(roleId === "4"
//       ? [
//           {
//             label: "Basic Profile",
//             icon: Groups2Icon,
//             path: "/Profile",
//           },
//           {
//             label: "Resource Identification",
//             icon: AccountBoxIcon,
//             subItems: [
//               {
//                 label: "Line Department Details",
//                 icon: NoteAddIcon,
//                 subItems: [
//                   { label: "Add", path: "/line-department-details", icon: AddIcon },
//                   { label: "Manage", path: "/line-department-details-manage", icon: ManageAccountsIcon },
//                 ],
//               },
//             ],
//           },
//           {
//             label: "View Schedule Meeting",
//             icon: AccountCircleIcon,
//             subItems: [
//               { label: "Gram Sabha Meeting", path: "/view-gram-sabha-meeting", icon: Groups2Icon },
//             ],
//           },
//         ]
//       : []),

//     ...(roleId === "7" || roleId === "8" || roleId === "3"
//       ? [
//           {
//             label: "Gram Sabha Scheduled Meetings",
//             icon: Groups2Icon,
//             path: "/ViewMeetingForGramSabhaAdmin",
//           },
//         ]
//       : []),

//     {
//       label: "Logout",
//       path: "/logout",
//       icon: LogoutIcon,
//     },
//   ];

//   const renderMenuItem = (item, index) => {
//     const IconComponent = item.icon;
//     const isActive = activeMenu === item.path;

//     if (item.subItems) {
//       const subMenu = (
//         <SubMenu
//           key={index}
//           icon={<IconComponent style={{ fontSize: 18 }} />}
//           label={sidebar ? item.label : ""}
//           className="sidebar-submenu"
//         >
//           {item.subItems.map((subItem, subIndex) => {
//             if (subItem.subItems) {
//               return (
//                 <SubMenu
//                   key={`${index}-${subIndex}`}
//                   icon={<subItem.icon style={{ fontSize: 16 }} />}
//                   label={subItem.label}
//                   className="sidebar-submenu-nested"
//                 >
//                   {subItem.subItems.map((nestedItem, nestedIndex) => (
//                     <Link
//                       key={`${index}-${subIndex}-${nestedIndex}`}
//                       to={nestedItem.path}
//                       style={{ textDecoration: "none" }}
//                       onClick={() => setActiveMenu(nestedItem.path)}
//                     >
//                       <MenuItem
//                         icon={<nestedItem.icon style={{ fontSize: 14 }} />}
//                         className={`sidebar-menu-item ${activeMenu === nestedItem.path ? "active" : ""}`}
//                       >
//                         {nestedItem.label}
//                       </MenuItem>
//                     </Link>
//                   ))}
//                 </SubMenu>
//               );
//             }
//             return (
//               <Link
//                 key={`${index}-${subIndex}`}
//                 to={subItem.path}
//                 style={{ textDecoration: "none" }}
//                 onClick={() => setActiveMenu(subItem.path)}
//               >
//                 <MenuItem
//                   icon={<subItem.icon style={{ fontSize: 16 }} />}
//                   className={`sidebar-menu-item ${activeMenu === subItem.path ? "active" : ""}`}
//                 >
//                   {subItem.label}
//                 </MenuItem>
//               </Link>
//             );
//           })}
//         </SubMenu>
//       );

//       // Show tooltip for submenu when sidebar is collapsed
//       if (!sidebar) {
//         return (
//           <Tooltip key={index} title={item.label} placement="right" arrow>
//             <div>{subMenu}</div>
//           </Tooltip>
//         );
//       }

//       return subMenu;
//     }

//     const menuItem = (
//       <Link
//         to={item.path}
//         style={{ textDecoration: "none" }}
//         onClick={() => setActiveMenu(item.path)}
//       >
//         <MenuItem
//           icon={<IconComponent style={{ fontSize: 18 }} />}
//           className={`sidebar-menu-item ${isActive ? "active" : ""}`}
//         >
//           {sidebar ? item.label : ""}
//         </MenuItem>
//       </Link>
//     );

//     // Show tooltip when sidebar is collapsed
//     if (!sidebar) {
//       return (
//         <Tooltip key={index} title={item.label} placement="right" arrow>
//           <div>{menuItem}</div>
//         </Tooltip>
//       );
//     }

//     return <div key={index}>{menuItem}</div>;
//   };

//   useEffect(() => {
//     setActiveMenu(location.pathname);
//     fetchData();
//   }, [location]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     if (user_id == 2) {
//       try {
//         const res = await getSacivDetails(token, user_id);
//         setSachivDetails(res.data.result[0]);
//       } catch (error) {
//         console.error("Error fetching profile data:", error);
//       }
//     }
//   };

//   return (
//     <div className="sidebar-wrapper">
//       <Sidebar 
//         className="sidebar hide-on-print" 
//         collapsed={!sidebar}
//         width="220px"
//         collapsedWidth="60px"
//         backgroundColor="#0D1642"
//       >
//         <Menu>
//           {/* Logo Section */}
//           <div className="sidebar-header">
//             <img
//               src="logo.png"
//               alt="Logo"
//               className="sidebar-logo"
//             />
//             {sidebar && (
//               <div className="sidebar-brand">
//                 <h5>Department of Haryana</h5>
//               </div>
//             )}
//           </div>

//           {/* User Info */}
//           {sidebar && (
//             <div className="sidebar-user-info">
//               <span className="user-name">
//                 {user_id == 2 ? sachivDetails.name : username}
//               </span>
//               <span className="user-role">({role})</span>
//             </div>
//           )}

//           {/* Divider */}
//           <div className="sidebar-divider"></div>

//           {/* Menu Items */}
//           <div className="sidebar-menu-container">
//             {sidebarMenuItems.map((item, index) => renderMenuItem(item, index))}
//           </div>
//         </Menu>
//       </Sidebar>
//     </div>
//   );
// };

// export default Sidebars;



import { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import SummarizeIcon from "@mui/icons-material/Summarize";
import "./Sidebar.css";
import Groups2Icon from "@mui/icons-material/Groups2";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import AddIcon from "@mui/icons-material/Add";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { getSacivDetails } from "../api/User";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BarChartIcon from "@mui/icons-material/BarChart";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleOutlined from "@mui/icons-material/CheckCircle";

const Sidebars = ({ sidebar }) => {
  const [activeMenu, setActiveMenu] = useState("/");
  const location = useLocation();
  const roleId = sessionStorage.getItem("role_id");
  const user_id = sessionStorage.getItem("user_id");
  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("role");
  const username = sessionStorage.getItem("username");
  const [sachivDetails, setSachivDetails] = useState([]);

  const sidebarMenuItems = [
    ...(roleId === "2"
      ? [
        {
          label: "Gram Sabha Scheduled Meetings",
          icon: SummarizeIcon,
          path: "/gram-sabha-meeting",
        },
        {
          label: "Minutes of Gram Sabha",
          icon: Groups2Icon,
          path: "/gram-sabha-mom",
        },
        {
          label: "Gram Sabha Agenda Points",
          icon: SummarizeIcon,
          path: "/gram-sabha-inspection",
        },
        {
          label: "Reports",
          icon: BarChartIcon,
          subItems: [
            {
              label: "Detailed report of Special Gram Sabha Gram sachiv",
              icon: BarChartIcon,
              path: "/gram-sachiv-report",
            },
            {
              label: "Special Gram Sabha Status",
              icon: BarChartIcon,
              path: "/special-gram-sabha-status",
            },
            {
              label: "Panchayatwise Status of Special Gram Sabha",
              icon: BarChartIcon,
              path: "/district-sachiv-report",
            },
            {
              label: "Districtwise GS Meeting Compliance",
              icon: BarChartIcon,
              path: "/districtwise-gs-compliance-sachiv",
            },
            {
              label: "Scheme Verification Report",
              icon: BarChartIcon,
              path: "/scheme-verification-ceo",
            },
            {
              label: "Income Verification Report",
              icon: BarChartIcon,
              path: "/income-verification-ceo",
            },
            {
              label: "General Gram Sabha Status",
              icon: BarChartIcon,
              path: "/general-gram-sabha-status-admin",
            },
          ],
        },
      ]
      : []),



    ...(roleId === "1"
      ? [
        {
          label: "Gram Sabha Scheduled Meetings",
          icon: Groups2Icon,
          path: "/ViewMeetingForGramSabhaAdmin",
        },
        //   {
        //   label: "Minutes of Gram Sabha",
        //   icon: Groups2Icon,
        //   path: "/gram-sabha-mom",
        // },

        {
          label: "Gram Sabha Agenda Points",
          icon: BarChartIcon,
          path: "/gram-sabha-inspection",
        },
        {
          label: "Reports",
          icon: BarChartIcon,
          subItems: [
            {
              label: "District wise Reports",
              icon: BarChartIcon,
              path: "/ceozp-report",
            },
            {
              label: "Gram Sabha Report",
              icon: BarChartIcon,
              path: "/gram-sabha-report",
            },
            {
              label: "Income Verification Report",
              icon: BarChartIcon,
              path: "/scheme-report",
            },
            {
              label: "Special Gram Sabha Status",
              icon: BarChartIcon,
              path: "/special-gram-sabha-status",
            },
            {
              label: "Admin Report",
              icon: BarChartIcon,
              path: "/admin-report",
            },
            {
              label: "Districtwise Status of Special Gram Sabha",
              icon: BarChartIcon,
              path: "/district-admin-report",
            },
            {
              label: "Districtwise GS Meeting Compliance",
              icon: BarChartIcon,
              path: "/districtwise-gs-compliance-admin",
            },
            {
              label: "General Gram Sabha Status",
              icon: BarChartIcon,
              path: "/general-gram-sabha-status-admin",
            },


          ],
        },
      ]
      : []),

    ...(roleId === "4"
      ? [
        {
          label: "Basic Profile",
          icon: Groups2Icon,
          path: "/Profile",
        },
        {
          label: "Resource Identification",
          icon: AccountBoxIcon,
          subItems: [
            {
              label: "Line Department Details",
              icon: NoteAddIcon,
              subItems: [
                { label: "Add", path: "/line-department-details", icon: AddIcon },
                { label: "Manage", path: "/line-department-details-manage", icon: ManageAccountsIcon },
              ],
            },
          ],
        },
        {
          label: "View Schedule Meeting",
          icon: AccountCircleIcon,
          subItems: [
            { label: "Gram Sabha Meeting", path: "/view-gram-sabha-meeting", icon: Groups2Icon },
          ],
        },
      ]
      : []),

    ...(roleId === "5"
      ? [
        {
          label: "Reports",
          icon: BarChartIcon,
          subItems: [
            {
              label: "District wise Reports",
              icon: BarChartIcon,
              path: "/ceozp-report",
            },
            {
              label: "Income Verification Report",
              icon: BarChartIcon,
              path: "/scheme-report",
            },
            {
              label: "Special Gram Sabha Status",
              icon: BarChartIcon,
              path: "/special-gram-sabha-status",
            },
            {
              label: "Widow Pension Report",
              icon: BarChartIcon,
              path: "/widow-pension",
            },
            {
              label: "Disability Pension Report",
              icon: BarChartIcon,
              path: "/disability-pension",
            },
            {
              label: "Deen Dayal Laado Lakshmi Yojna Report",
              icon: BarChartIcon,
              path: "/deen-dayal-laado-lakshmi-yojna",
            },
            {
              label: "Old Age Saman Allowance Report",
              icon: BarChartIcon,
              path: "/old-age-saman-allowance",
            }
          ],
        },
      ]
      : []),
    ...(roleId === "6"
      ? [
        {
          label: "Reports",
          icon: BarChartIcon,
          subItems: [
            {
              label: "District wise Reports",
              icon: BarChartIcon,
              path: "/ceozp-report",
            },
            {
              label: "Income Verification Report",
              icon: BarChartIcon,
              path: "/scheme-report",
            },
            {
              label: "Special Gram Sabha Status",
              icon: BarChartIcon,
              path: "/special-gram-sabha-status",
            },
            {
              label: "Widow Pension Report",
              icon: BarChartIcon,
              path: "/widow-pension",
            },
            {
              label: "Disability Pension Report",
              icon: BarChartIcon,
              path: "/disability-pension",
            },
            {
              label: "Deen Dayal Laado Lakshmi Yojna Report",
              icon: BarChartIcon,
              path: "/deen-dayal-laado-lakshmi-yojna",
            },
            {
              label: "Old Age Saman Allowance Report",
              icon: BarChartIcon,
              path: "/old-age-saman-allowance",
            }
          ],
        },
      ]
      : []),


    ...(roleId === "7" || roleId === "8" || roleId === "3"
      ? [
        {
          label: "Gram Sabha Scheduled Meetings",
          icon: Groups2Icon,
          path: "/ViewMeetingForGramSabhaAdmin",
        },

        //   {
        //   label: "Minutes of Gram Sabha",
        //   icon: Groups2Icon,
        //   path: "/gram-sabha-mom",
        // },
      ]
      : []),
    ...(roleId === "3"
      ? [
        // {
        //   label: "Gram Sabha Scheduled Meetings",
        //   icon: SummarizeIcon,
        //   path: "/gram-sabha-meeting",
        // },
        // {
        //   label: "Minutes of Gram Sabha",
        //   icon: Groups2Icon,
        //   path: "/gram-sabha-mom",
        // },
        {
          label: "Gram Sabha Agenda Points",
          icon: BarChartIcon,
          path: "/gram-sabha-inspection",
        },
        {
          label: "Reports",
          icon: BarChartIcon,
          subItems: [
            {
              label: "Special Gram Sabha Status",
              icon: BarChartIcon,
              path: "/special-gram-sabha-status",
            },
            {
              label: "General Gram Sabha Status",
              icon: BarChartIcon,
              path: "/general-gram-sabha-status-admin",
            },
          ],
        },
      ]
      : []),

    ...((roleId === "8")
      ? [

        {
          label: "Gram Sabha Agenda Points",
          icon: BarChartIcon,
          path: "/gram-sabha-inspection",
        },
        {
          label: "Reports",
          icon: BarChartIcon,
          subItems: [
            {
              label: "Detailed report of Special Gram Sabha CEO",
              icon: BarChartIcon,
              path: "/gram-sabha-report-ceo",
            },
            {
              label: "Special Gram Sabha Status",
              icon: BarChartIcon,
              path: "/special-gram-sabha-status",
            },
            {
              label: "District Status of Special Gram Sabha",
              icon: BarChartIcon,
              path: "/district-ceo-report",
            },
            {
              label: "Districtwise GS Meeting Compliance",
              icon: BarChartIcon,
              path: "/districtwise-gs-compliance-ceo",
            },
            {
              label: "Scheme Verification Report (CEO ZP)",
              icon: BarChartIcon,
              path: "/scheme-verification-ceo",
            },
            {
              label: "Income Verification Report (CEO ZP)",
              icon: BarChartIcon,
              path: "/income-verification-ceo",
            },
            {
              label: "General Gram Sabha Status",
              icon: BarChartIcon,
              path: "/general-gram-sabha-status-admin",
            },
          ],
        },
      ]
      : []),
    ...(roleId === "7"
      ? [

        {
          label: "Gram Sabha Agenda Points",
          icon: BarChartIcon,
          path: "/gram-sabha-inspection",
        },
        {
          label: "Reports",
          icon: BarChartIcon,
          subItems: [
            {
              label: "Detailed report of Special Gram Sabha BDPO",
              icon: BarChartIcon,
              path: "/gram-sabha-report-bdpo",
            },
            {
              label: "Special Gram Sabha Status",
              icon: BarChartIcon,
              path: "/special-gram-sabha-status",
            },
            {
              label: "Blockwise Status of Special Gram Sabha",
              icon: BarChartIcon,
              path: "/district-bdpo-report",
            },
            {
              label: "Districtwise GS Meeting Compliance",
              icon: BarChartIcon,
              path: "/districtwise-gs-compliance-bdpo",
            },
            {
              label: "Scheme Verification Report",
              icon: BarChartIcon,
              path: "/scheme-verification-ceo",
            },
            {
              label: "Income Verification Report",
              icon: BarChartIcon,
              path: "/income-verification-ceo",
            },
            {
              label: "General Gram Sabha Status",
              icon: BarChartIcon,
              path: "/general-gram-sabha-status-admin",
            },
          ],
        },
      ]
      : []),


    {
      label: "Logout",
      path: "/logout",
      icon: LogoutIcon,
    },
  ];

  const renderMenuItem = (item, index) => {
    const IconComponent = item.icon;
    const isActive = activeMenu === item.path;

    if (item.subItems) {
      const subMenu = (
        <SubMenu
          key={index}
          icon={<IconComponent style={{ fontSize: 18 }} />}
          label={sidebar ? item.label : ""}
          className="sidebar-submenu"
        >
          {item.subItems.map((subItem, subIndex) => {
            if (subItem.subItems) {
              return (
                <SubMenu
                  key={`${index}-${subIndex}`}
                  icon={<subItem.icon style={{ fontSize: 16 }} />}
                  label={subItem.label}
                  className="sidebar-submenu-nested"
                >
                  {subItem.subItems.map((nestedItem, nestedIndex) => (
                    <Link
                      key={`${index}-${subIndex}-${nestedIndex}`}
                      to={nestedItem.path}
                      style={{ textDecoration: "none" }}
                      onClick={() => setActiveMenu(nestedItem.path)}
                    >
                      <MenuItem
                        icon={<nestedItem.icon style={{ fontSize: 14 }} />}
                        className={`sidebar-menu-item ${activeMenu === nestedItem.path ? "active" : ""}`}
                      >
                        {nestedItem.label}
                      </MenuItem>
                    </Link>
                  ))}
                </SubMenu>
              );
            }
            return (
              <Link
                key={`${index}-${subIndex}`}
                to={subItem.path}
                style={{ textDecoration: "none" }}
                onClick={() => setActiveMenu(subItem.path)}
              >
                <MenuItem
                  icon={<subItem.icon style={{ fontSize: 16 }} />}
                  className={`sidebar-menu-item ${activeMenu === subItem.path ? "active" : ""}`}
                >
                  {subItem.label}
                </MenuItem>
              </Link>
            );
          })}
        </SubMenu>
      );

      // Show tooltip for submenu when sidebar is collapsed
      if (!sidebar) {
        return (
          <Tooltip key={index} title={item.label} placement="right" arrow>
            <div>{subMenu}</div>
          </Tooltip>
        );
      }

      return subMenu;
    }

    const menuItem = (
      <Link
        to={item.path}
        style={{ textDecoration: "none" }}
        onClick={() => setActiveMenu(item.path)}
      >
        <MenuItem
          icon={<IconComponent style={{ fontSize: 18 }} />}
          className={`sidebar-menu-item ${isActive ? "active" : ""}`}
        >
          {sidebar ? item.label : ""}
        </MenuItem>
      </Link>
    );

    // Show tooltip when sidebar is collapsed
    if (!sidebar) {
      return (
        <Tooltip key={index} title={item.label} placement="right" arrow>
          <div>{menuItem}</div>
        </Tooltip>
      );
    }

    return <div key={index}>{menuItem}</div>;
  };

  useEffect(() => {
    setActiveMenu(location.pathname);
    fetchData();
  }, [location]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    if (user_id == 2) {
      try {
        const res = await getSacivDetails(token, user_id);
        setSachivDetails(res.data.result[0]);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    }
  };

  return (
    <div className="sidebar-wrapper">
      <Sidebar
        className="sidebar hide-on-print"
        collapsed={!sidebar}
        width="220px"
        collapsedWidth="60px"
        backgroundColor="#0D1642"
      >
        <Menu>
          {/* Logo Section */}
          <div className="sidebar-header">
            <img
              src="logo.png"
              alt="Logo"
              className="sidebar-logo"
            />
            {sidebar && (
              <div className="sidebar-brand">
                <h5>Department of Haryana</h5>
              </div>
            )}
          </div>

          {/* User Info */}
          {sidebar && (
            <div className="sidebar-user-info">
              <span className="user-name">
                {user_id == 2 ? sachivDetails.name : username}
              </span>
              <span className="user-role">({role})</span>
            </div>
          )}

          {/* Divider */}
          <div className="sidebar-divider"></div>

          {/* Menu Items */}
          <div className="sidebar-menu-container">
            {sidebarMenuItems.map((item, index) => renderMenuItem(item, index))}
          </div>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default Sidebars;
